import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dropdown } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "../../assets/styles/local/Stock.css";
import plusIcon from "../../assets/icons/plus-dotted-blue-icon.svg";
import Calender from "../../assets/icons/Calendar with interaction.svg";
import Header from "../../layouts/Header";
import AppDatePicker from "../../components/Common/AppDatePicker";
import moment from "moment";
import { FetchActiveUsers } from "../../redux/actions/action";
import "../../assets/styles/local/payroll.css";
import PayrollActiveUserModal from "./PayrollActiveUserModal";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import simpleRequest from "../../utils/helpers/simpleRequest";
import { useLocation } from "react-router-dom";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const statusList = {
  NOT_SUBMITTED: "08dab011-a6cf-4069-887e-83e5f3473116",
  PENDING: "08dab011-a6cf-4069-887e-83e5f3473117",
  CLOSED: "08dab011-a6cf-4069-887e-83e5f3473118",
};

const OffCyclePayroll = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    state: { state },
  } = useLocation();
  const companyId = window.localStorage.getItem("companyid");
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [date, setDate] = useState(new Date());
  const [users, setUsers] = useState([]);
  const [rows, setRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState(
    moment().startOf("isoWeek").format("YYYY-MM-DDTHH:mm:ss")
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("isoWeek").format("YYYY-MM-DDTHH:mm:ss")
  );
  const [payrollSettingId, setPayrollSettingId] = useState("");

  const activeStatusResponse = useSelector(
    (state) => state.user.activeStatusResponse
  );

  const totalCost = useMemo(
    () =>
      rows.reduce(
        (acc, curr) => +acc + (+curr?.grossWage + +curr?.companyTaxes),
        0
      ),
    [rows]
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Payroll").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const handleAddRow = (user) => {
    let list = [...rows];
    const userIndex = list.findIndex((item) => item?.userId === user?.userid);
    if (userIndex >= 0) return;
    const newRow = {
      members: user.firstname,
      grossWage: user.wagerate,
      employeeTaxes: "",
      netWage: "",
      companyTaxes: "",
      totalPayrollCost: "",
      description: "",
      userId: user?.userid,
    };
    setRows([...rows, newRow]);
  };

  const handleDeleteRow = (index) => {
    setRows(rows.filter((_, rowIndex) => rowIndex !== index));
  };

  const filteredUsers = users?.filter((user) =>
    user.firstname.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const datePickerFunc = (val) => {
    if (val != undefined) {
      setDate(val);
      setCalendarIsOpen(!calendarIsOpen);
    }
  };

  const getRange = () => {
    if (state.period === "weekly") {
      const currentDate = moment();
      const startOfWeek = currentDate.clone().day(state.weekStartingDay);
      const endOfWeek = startOfWeek.clone().add(6, "days");
      setStartDate(
        moment(startOfWeek).startOf("day").format("YYYY-MM-DDTHH:mm:ss")
      );
      setEndDate(
        moment(endOfWeek).startOf("day").format("YYYY-MM-DDTHH:mm:ss")
      );
    } else if (state.period === "monthly") {
      const currentDate = moment();
      const startOfMonth = currentDate.clone().date(state.monthStartingDay);
      const endOfMonth = currentDate.clone().endOf("month");
      setStartDate(
        moment(startOfMonth).startOf("day").format("YYYY-MM-DDTHH:mm:ss")
      );
      setEndDate(
        moment(endOfMonth).startOf("day").format("YYYY-MM-DDTHH:mm:ss")
      );
    }
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] =
      field === "description" ? value : parseFloat(value); // Update the field with numeric value
    setRows(updatedRows);
  };

  const calculateNetWage = (grossWage, employeeTaxes) =>
    grossWage - employeeTaxes;
  const calculateTotalPayrollCost = (grossWage, companyTaxes) =>
    +grossWage + +companyTaxes;

  const handleSubmit = async () => {
    let data = new Array();
    rows?.map((item) =>
      data.push({
        userId: item?.userId,
        grosswage: item?.grossWage,
        employeeTax: item?.employeeTaxes,
        netwage: Number(item?.grossWage) - Number(item?.employeeTaxes),
        companyTax: item?.companyTaxes,
        totalPayrollCost: Number(item?.grossWage) + Number(item?.companyTaxes),
        description: item?.description,
      })
    );
    const payload = {
      payrollSettingId: payrollSettingId,
      payrollType: "Off Cycle",
      payrollPeriodStart: moment(startDate).toISOString(),
      payrollPeriodEnd: moment(endDate).toISOString(),
      payday: moment(date).toISOString(),
      submittedDate: moment().toISOString(),
      offCyclePayrollUser: data,
      statusId: statusList.PENDING,
      totalCost: totalCost,
    };
    const resp = await simpleRequest(
      `/api/Payroll/AddOffCyclePayroll`,
      "post",
      payload
    );
    if (resp?.status === true) history.goBack();
  };

  const getPayrollSetting = async () => {
    const resp = await simpleRequest(
      `/api/Payroll/FetchPayrollSetting`,
      "post",
      {}
    );
    if (resp?.status === true)
      setPayrollSettingId(resp?.data?.payrollSettingId);
  };

  useEffect(() => {
    dispatch(FetchActiveUsers(companyId));
  }, [dispatch, companyId]);

  useEffect(() => {
    if (activeStatusResponse != null) {
      if (activeStatusResponse?.status && activeStatusResponse?.data) {
        setUsers(activeStatusResponse?.data);
      }
    }
  }, [activeStatusResponse]);

  useEffect(() => {
    getPayrollSetting();
    getRange();
  }, []);

  return (
    <>
      <Header
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/payroll");
              }}
            >
              {/* Payroll */}
              {t("Payroll")}
            </div>
            <p className="products-and-parts-sub-title products_and_parts_sub_title">
              {/* Off Cycle Payroll */}
              {t("Off Cycle Payroll")}
            </p>
          </div>
        }
      />
      <div className="container-fluid mainWrapper">
        <div className=" stock row col-12">
          <div className="col-sm-12 stockCards">
            <div className="payroll-container col-sm-12 mb-2">
              <div className="col-sm-3">
                {/* Pay period: */}
                {t("Pay period")}:{" "}
                <span className="pay-period">
                  {moment(startDate).format("DD MMM")} -{" "}
                  {moment(endDate).format("DD MMM")}
                </span>
              </div>
              <div className="col-sm-3 d-flex gap-2">
                {/* Payday: */}
                {t("Payday")}:{" "}
                <div className="d-flex gap-2 bg-transparent">
                  <img
                    style={{ cursor: "pointer" }}
                    src={Calender}
                    alt=""
                    onClick={() => setCalendarIsOpen(!calendarIsOpen)}
                  />
                  <span className="pay-period">
                    <AppDatePicker
                      inputClassNames="bg-transparent"
                      open={calendarIsOpen}
                      selected={date}
                      onChange={(val) => {
                        datePickerFunc(val);
                        setCalendarIsOpen(false);
                      }}
                      onSelect={(d, event) => event.preventDefault()}
                      dateFormat="dd/MM/yyyy"
                    />
                  </span>
                </div>
              </div>
              <div className="col-sm-3 justify-content-end d-flex width-min-content">
                <div className="row gap-1">
                  <div className="col pe-2">
                    <button
                      className="po-btn-cancel m-auto"
                      onClick={() => history.push("/payroll")}
                    >
                      {/* Cancel */}
                      {t("Cancel")}
                    </button>
                  </div>
                  <div className="col ps-2">
                    <button
                      className="po-btn-complete m-auto"
                      onClick={handleSubmit}
                    >
                      {/* Submit */}
                      {t("Submit")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="tableWrapper-payroll">
              <div>
                <table className="table offcyc-table mb-0">
                  <thead>
                    <tr className="off-cycle-header">
                      <th style={{ width: "15%" }}>
                        {/* Members */}
                        {t("Members")}
                      </th>
                      <th>
                        {/* Gross Wage */}
                        {t("Gross Wage")}
                      </th>
                      <th>
                        {/* Employee Taxes */}
                        {t("Employee Taxes")}
                      </th>
                      <th
                        style={{
                          fontWeight: "bold",
                          color: "#707070",
                          width: "10%",
                        }}
                      >
                        {/* Net Wage */}
                        {t("Net Wage")}
                      </th>
                      <th>
                        {/* Company Taxes */}
                        {t("Company Taxes")}
                      </th>
                      <th style={{ fontWeight: "bold", color: "#707070" }}>
                        {/* Total Payroll Cost */}
                        {t("Total Payroll Cost")}
                      </th>
                      <th style={{ width: "25%" }}>
                        {/* Description */}
                        {t("Description")}
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody style={{ border: "none" }}>
                    {rows.map((row, index) => (
                      <tr key={index}>
                        <td style={{ padding: "0.5rem 0.75rem", width: "15%" }}>
                          {row.members}
                        </td>
                        <td style={{ padding: "0.5rem 0.75rem" }}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <input
                              type="number"
                              value={row.grossWage}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "grossWage",
                                  e.target.value
                                )
                              }
                              style={styles.inputStyle}
                            />
                          </div>
                        </td>
                        <td style={{ padding: "0.5rem 0.75rem" }}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <input
                              type="number"
                              value={row.employeeTaxes}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "employeeTaxes",
                                  e.target.value
                                )
                              }
                              style={styles.inputStyle}
                            />
                          </div>
                        </td>
                        <td style={styles.wageText}>
                          {europeanFormatWithSymbol(
                            calculateNetWage(row.grossWage, row.employeeTaxes)
                          )}
                        </td>
                        <td style={{ padding: "0.5rem 0.75rem" }}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <input
                              type="number"
                              value={row.companyTaxes}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "companyTaxes",
                                  e.target.value
                                )
                              }
                              style={styles.inputStyle}
                              // onFocus={(e) => (e.target.style.border = "1px solid #007bff")}
                              // onBlur={(e) => (e.target.style.border = "none")}
                            />
                          </div>
                        </td>
                        <td style={styles.wageText}>
                          {europeanFormatWithSymbol(
                            calculateTotalPayrollCost(
                              row.grossWage,
                              row.companyTaxes
                            )
                          )}
                        </td>
                        <td style={{ width: "25%" }}>
                          <input
                            style={styles.inputDesc}
                            value={row.description}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "description",
                                e.target.value
                              )
                            }
                          />
                        </td>
                        <td>
                          <Button
                            type="text"
                            style={{ color: "black" }} // Set color to black
                            icon={<DeleteOutlined />}
                            onClick={() => handleDeleteRow(index)}
                          ></Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Ant Design Dropdown */}
                <Dropdown
                  overlay={
                    <PayrollActiveUserModal
                      filteredUsers={filteredUsers}
                      handleAddRow={handleAddRow}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  }
                  trigger={["click"]}
                  placement="bottomLeft"
                >
                  <img
                    src={plusIcon}
                    className="offc"
                    style={{ cursor: "pointer", marginTop: "10px" }}
                    alt="Add Row"
                  />
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OffCyclePayroll;

const styles = {
  inputStyle: {
    border: "none",
    outline: "none",
    background: "transparent",
    width: "100%",
    textAlign: "start",
  },
  wageText: {
    padding: "0.5rem 0.75rem",
    color: "#707070",
    overflow: "hidden",
    width: "10%",
  },
  inputDesc: {
    border: "none",
    outline: "none",
    background: "transparent",
    width: "100%",
    textAlign: "start",
    color: "#333",
    fontWeight: 500,
  },
};
